app.ApplicantList = (
    function () {
        var appList = {

            Index: function () {

                //load the grid when the doc is ready Since this is mobile it needs to be triggered for the IsMobile
                app.page.components["ApplicantList"][0].refreshGrid();

                // initialize tooltips when grid is refreshed
                $(document).on("component-bind-view-mode-complete-ApplicantList",
                    function() {
                        $('[data-toggle="tooltip"]').tooltip();
                    });

                //also make sure to assign interview checkbox functionality every time the grid is done loading again
                $(document).on("component-bind-view-mode-complete-ApplicantList",
                    function () {

                        app.ApplicantList.InterviewCheckboxInit();

                        //Assign the mobile view select all button functionality
                        $(".selectAllCheckbox, #gridSelectAllGroupSelect").on("change",
                            function () {
                                if ($(this).is(":checked")) {
                                    $("input[name='SelectCheckbox']").prop('checked', true);
                                    $(".selectAllCheckbox").prop('checked', true);
                                    $("#gridSelectAllGroupSelect").prop('checked', true);
                                } else {
                                    $("input[name='SelectCheckbox']").prop('checked', false);
                                    $(".selectAllCheckbox").prop('checked', false);
                                    $("#gridSelectAllGroupSelect").prop('checked', false);
                                }
                            });

                        //Every time the email checkbox changes run this check to determine if "select all" needs to be unchecked
                        $(".SelectCheckbox").on("change", function () {
                            //If unchecking and the select all is selected.
                            if ($(".SelectCheckbox").not(':checked').length !== 0) {
                                //turn off select all
                                $("#gridSelectAllGroupSelect").prop('checked', false);
                                $(".selectAllCheckbox").prop('checked', false);
                            } else
                            {
                                $("#gridSelectAllGroupSelect").prop('checked', true);
                                $(".selectAllCheckbox").prop('checked', true);
                            }
                        });

                        //Every time a sort is clicked, make sure that we clear out any value in the assessment score
                        //drop down so that custom logic doe not override the sorting
                        $("a[data-role='sort-action']").on("click", function (ev) {
                            ev.preventDefault();
                            $("select[Name='SelectedAssessmentScoreType']").val(null);
                            app.page.components["ApplicantList"][0].refreshGrid();
                        });

                        //We need to tell the comments code that the data has loaded in order fo the comment modal to work on this page
                        $(document).trigger("bind-comments-modal");
                    });

                $("#GetEmailButton").on("click",
                    function () {
                        //When user clicks the group email button
                        var emails = [];
                        var resultString = "";
                        $("#EmailTextArea").val("");
                        //Get all of the selected group emails
                        $(".SelectCheckbox:checked").each(
                            function () {
                                //Get email address (grid)
                                var email = $(this).closest('tr').find("input[name='EmailAddress']").val();

                                //if mobile...
                                if (!email) {
                                    email = $(this).val();
                                }

                                //add selected email to the array
                                emails.push(email);
                            });

                        //Now that we have all of the emails, build the string
                        $(emails).each(function (index) {

                            if (index === 0) {
                                resultString += emails[index];
                            }
                            else
                            {
                                resultString +=  "; " + emails[index];
                            }
                        });

                        //Set modal text area with new string
                        $("#EmailTextArea").val(resultString);
                        //open modal for user
                        $("#CopyEmailModal").modal("show");
                    });

                $("#GetCsvButton").on("click", function (e) {
                    var frm = $("#csvForm");
                    //Get all selected application Ids
                    var appIds = [];
                    $(".SelectCheckbox:checked").each(
                        function (index, element) {
                            //Get email address (grid)
                            var id = $(element).closest('tr').find("input[name='Application.Index']").val();

                            //if mobile...
                            if (!id) {
                               id =  $(element).data("application-id");
                            }

                            //add selected id to the array
                            appIds.push(id);
                        });

                    $(frm).find("[name='ApplicationIds']").val(appIds);
                    $(frm).find("[name='VacancyId']").val($("input[name='Id']").val());
                });

                //Modal Copy email to clipboard functionality
                $("#CopyEmailsButton").on("click", function() {
                    var copyText = $("#EmailTextArea");

                    copyText.select();
                    document.execCommand("copy");
                    toastr["success"]("Copied to clipboard.");
                });
                //Clear button functionality. Needs to override component framework stuff because of special logic with years experience fields
                $("button[data-role='clear-filter']").on("click", function (ev) {

                    ev.preventDefault();

                    //Do the component framework stuff (not working?)
                    app.input.clearForm();

                    //Now set int values
                    $("input[Name='MinTeacherExperience']").val(0);
                    $("input[Name='MaxTeacherExperience']").val(10);
                    $("input[Name='MinAdminExperience']").val(0);
                    $("input[Name='MaxAdminExperience']").val(10);

                    $("select[Name='SelectedAssessmentScoreType']").val(null);
                    $("select[Name='SelectedSelectedSortDirection']").val("False");

                    $("input[Name='SelectedLicenseOptions']").prop('checked', false);
                    $("select[Name='SelectedFilterItem']").val("All");

                    $("input[Name='SearchText']").val(null);
                    //Clear last sort field so that the sort doesnt persist when resetting filters
                    $("input[Name='LastSortField']").val(null);
                    //Remove all sort stuff before the post
                    $("a[data-role='sort-action']").removeClass("desc");
                    $("a[data-role='sort-action']").removeClass("asc");
                    $("a[data-role='sort-action']").removeAttr("aria-sort");
                    $("a[data-role='sort-action']").removeData("role");

                    //Refresh the grid after reset
                    app.page.components["ApplicantList"][0].refreshGrid();
                });
            },

            InterviewCheckboxInit: function () {
                $(".Interview").on("change",
                    function () {
                        //Grab the row's application id (grid)
                        var applicationId = $(this).closest('tr').find("input[name='Application.Index']").val();

                        //if mobile...
                        if (!applicationId) {
                            applicationId = $(this).data("application-id");
                        }

                        //ajax post to the interview update endpoint
                        var postData = { ApplicationId: applicationId, WillInterview: $(this).is(':checked') };

                        $.ajax({
                            url: '/Employer/Vacancy/UpdateApplicantInterviewStatus',
                            data: postData,
                            type: "POST",
                            success: function (data) {
                                //Toast success
                                toastr["success"]("Applicant interview status changed");
                            },
                            error: function () {
                                //Toast error
                                toastr["error"]("Applicant interview status change failed. Please try again.");
                            }
                        });
                    }
                );
            }
        };

        return appList;
    }()
);